<template>
<div class="chapter">
<div class="inner_page">
<div class="section" id="title">
<div class="pseudo_margin_2"></div>
<div class="pseudo_margin_2"></div>
<div class="pseudo_margin_1"></div>
<p class="halftitle1"><span class="right_1" epub:type="pagebreak" id="page_x" title="x"><span class="right_1" epub:type="pagebreak" id="page_1" title="1">POST-</span></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Frontmatter03.vue?2efcd72b